export { SharedAuthenticationFeatureAuthenticationModule } from './lib/shared-authentication-feature-authentication.module';
export { AuthGuardService } from './lib/guards/auth-guard.service';
export { ROUTE_SIGNIN } from './lib/shared/routes';
